import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import { LEGACYIDENTIFIER } from '../../../shared/paths'
import CentreMapComponent from '../../components/centre-map'
import { centreType } from '../../types'
import pagesHoc from '../pages-hoc'
import withStores from '../../containers/with-stores'
import withStoreTitle from '../../containers/with-store-title'
import styles from './index.scss'

const getMetaData = ({ centre, storeTitle }) => {
  if (storeTitle) {
    return {
      title: `${storeTitle} Location at Westfield ${centre.title}`,
      description: `Westfield ${centre.title} ${storeTitle} - Check map locations and directions to help you find ${storeTitle} in Westfield ${centre.title}.`,
    }
  } else {
    return {
      title: `Westfield ${centre.title} Centre Map | Map of Stores in Centre`,
      description: `Locate your favourite store using our handy centre map with level by level directories of stores, key facilities and amenities at Westfield ${centre.title}.`,
    }
  }
}

const CentreMap = ({ centre, match, stores, location }) => {
  const entryId = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  }).entryId

  return (
    <div className={styles.mapContainer}>
      <CentreMapComponent
        centre={centre}
        stores={stores}
        legacyIdentifier={match.params[LEGACYIDENTIFIER]}
        entryId={entryId}
      />
    </div>
  )
}

CentreMap.propTypes = {
  centre: centreType,
  match: PropTypes.object.isRequired,
  stores: PropTypes.array,
  location: PropTypes.object,
}

export default withStores(withStoreTitle(pagesHoc(CentreMap, getMetaData)))
